import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "./auth";
import { ResendOtpDetails, clearUpdate } from "../actions";
import { Redirect, Link } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Button from "react-validation/build/button";
import * as validations from "../components/lib/validations";
import Modal from "react-responsive-modal";
import notification from "../utils/notification";
const keys = require("../config/keys");

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showforgot: false,
      // StudMobNo: "",
      UserId: "",
      modelOpen: false,
      ShowThankMsg: false,
      ShowOtpBox: true
    };
  }

  componentDidUpdate() {
    if (this.props.update.data) {
      notification(
        this.props.update.messageType,
        this.props.update.messageType,
        this.props.update.message
      );
      this.props.clearUpdate();
      // clearForm(this);
      // this.setState({ transactionDate: moment(), paymentModeId: 1 });
      // this.setState({ MstId: this.props.update.data.Id });
    }
  }

  onOpenModal = () => {
    this.setState({ modelOpen: true });
  };

  onCloseModal = () => {
    this.setState({ modelOpen: false });
  };

  showForgotPassword = () => {
    this.setState({ showforgot: true });
  };

  showLogin = () => {
    this.setState({ showforgot: false });
  };

  userLogin = event => {
    event.preventDefault();
    this.props.fetchUser({
      username: this.state.username,
      password: this.state.password
    });
  };

  onInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onEventChange = e => {
    this.setState({ [e.target.name]: e.target.checked });
  };

  SendOTPCode = async () => {
    const UserData = {
      UserId: this.state.UserId || ""
      // StudMobNo: this.state.StudMobNo || ""
    };
    var isRegSuccess = await this.props.forgotPasswordSendOTP(UserData);
    if (isRegSuccess) {
      this.setState({ modelOpen: true, ShowThankMsg: false, ShowOtpBox: true });
    }
  };

  handleOtpSubmit = async e => {
    e.preventDefault();
    var userOtpData = {
      // UserId: this.props.userDetailOTPForgotPass.StudUserId,
      UserId: this.props.userDetailOTPForgotPass.AcUserId,
      OtpCode: this.state.otpNumber,
      NewPassword: this.state.password
    };
    var res = await this.props.checkVerifyOtpResetPassword(userOtpData);
    if (res.isOtpVerify) {
      this.setState({
        ShowThankMsg: true,
        ShowOtpBox: false,
        errorMsg: false
      });
      // setTimeout(() => {
      //   this.onCloseModal;
      // }, 5000);
    } else {
      this.setState({
        ShowThankMsg: false,
        ShowOtpBox: true,
        errorMsg: res.errorMsg
      });
    }
  };

  render() {
    const { showforgot } = this.state;
    if (
      this.props.auth.redirectToApplication === true &&
      this.props.auth.logOut === false &&
      this.props.auth.userType === 6
    ) {
      return <Redirect to="/Account/StudentAccount/Dashboard" />;
    }

    return (
      <div className="container d-table">
        <Modal
          open={this.state.modelOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          showCloseIcon={this.state.ShowThankMsg}
          center
          classNames={{
            overlay: "modalMsgBox modalPopupDesign onlyReg",
            modal: "modalPopupInner"
          }}
        >
          <Form
            onSubmit={this.handleOtpSubmit.bind(this)}
            className="text-center"
          >
            {this.state.ShowThankMsg && (
              <div className="regMassage">
                <strong>Thank you for change password!!!.</strong>
                <span style={{ fontSize: "18px" }}>
                  Your password change successfully.
                </span>
              </div>
            )}
            {this.state.ShowOtpBox && (
              <div className="modalVerify">
                <div className="regMassage modalTitle forgotTitle">
                  Please verify your OTP and change password
                </div>
                <div className="innerFormModal">
                  <div className="form-group">
                    <label className="required">Enter OTP</label>
                    <Input
                      type="number"
                      className="form-control otpBox"
                      id="otpNumber"
                      value={this.state.otpNumber}
                      validations={[validations.required]}
                      name="otpNumber"
                      label="OTP Number"
                      placeholder="Enter OTP"
                      onChange={this.onInputChange}
                    />
                    {this.state.errorMsg && (
                      <p style={{ color: "red" }}>Invalid OTP</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="required">New Password</label>
                    <Input
                      type="password"
                      className="form-control"
                      id="password"
                      name="password"
                      value={this.state.password || ""}
                      label="New Password"
                      validations={[validations.required, validations.isEqual]}
                      onChange={this.onInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label className="required">Confirm Password</label>
                    <Input
                      type="password"
                      className="form-control"
                      id="confirm"
                      name="confirm"
                      label="confirm Password"
                      validations={[validations.required, validations.isEqual]}
                    />
                  </div>
                  <div className="form-group mb-0">
                    <Button type="submit" className="btn btn-success btn-lg">
                      Submit
                    </Button>
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-info btn-lg"
                      onClick={this.props.ResendOtpDetails.bind(this, {
                        UserId:
                          this.props.userDetailOTPForgotPass.StudUserId || 0,
                        StudMobNo:
                          this.props.userDetailOTPForgotPass.PhoneNo || ""
                      })}
                    >
                      Resend OTP
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Form>
        </Modal>

        <div className="d-middel d-signup ">
          <div
            className={
              keys.websiteSetting.signUpContent === "nvu"
                ? "row justify-content-center login-text onlyLogin"
                : "row justify-content-center onlyLogin"
            }
          >
            <div
              className={
                keys.websiteSetting.signUpContent === "nvu"
                  ? "col-xs-3 col-lg-4 col-sm-8 col-xs-12 login_left_text"
                  : "col-xs-4 col-lg-4 col-sm-8 login_left"
              }
              dangerouslySetInnerHTML={{
                __html: keys.websiteSetting.LoginContent
              }}
            />
            <div className="col-xs-3 col-lg-4 col-sm-8 col-xs-12 login_right">
              {!showforgot && (
                <div className="signup-card">
                  <div className="login-header">
                    <h2>Login For Admission</h2>
                  </div>
                  <div className="login-body">
                    <Form onSubmit={this.userLogin.bind(this)}>
                      <div className="form-group">
                        <Input
                          id="username"
                          type="text"
                          name="username"
                          label="Username"
                          placeholder="Username"
                          validations={[validations.required]}
                          className="form-control"
                          onChange={this.onInputChange}
                        />
                      </div>
                      <div className="form-group mb-1">
                        <Input
                          id="password"
                          type="password"
                          name="password"
                          label="Password"
                          placeholder="Password"
                          validations={[validations.required]}
                          className="form-control"
                          onChange={this.onInputChange}
                        />
                      </div>
                      <div style={{ height: "20px" }}>
                        {this.props.auth.message && (
                          <div style={{ margin: 0 }} className="form-group">
                            <p style={{ margin: 0 }} className="text-danger">
                              {this.props.auth.message}
                            </p>
                          </div>
                        )}
                      </div>
                      <div className="form-group row justify-content-between mt-1">
                        <div className="col align-self-center">
                          <input type="checkbox" id="signed" name="signed" />
                          <label className="checkbox-inline" htmlFor="signed">
                            Keep signed in
                          </label>
                        </div>
                        <div className="col align-self-center text-right">
                          <span
                            className="g-font-size-12 url"
                            onClick={this.showForgotPassword}
                          >
                            Forgot password?
                          </span>
                        </div>
                      </div>
                      <div>
                        <Button
                          type="submit"
                          className="btn btn-primary btn-block btn-lg "
                        >
                          <i className="fa fa-sign-in" aria-hidden="true" />
                          Login
                        </Button>
                      </div>
                    </Form>
                  </div>
                  <div className="login-footer">
                    <p>
                      Don't have an account?{" "}
                      {keys.websiteSetting.signUpContent !== "nvu" ? (
                        <Link className="mb-0 url" to="/SignUp">
                          SignUp
                        </Link>
                      ) : (
                        <Link className="mb-0 url" to="/">
                          SignUp
                        </Link>
                      )}{" "}
                      Enquiry
                    </p>

                    <Link className="mb-0" to="/">
                      <i className="fa fa-angle-left" aria-hidden="true" /> Go
                      Back
                    </Link>
                  </div>
                </div>
              )}
              {showforgot && (
                <div className="">
                  <div className="login-header">
                    <p>
                      We'll send you an OTP on linked email/mobile to reset your
                      password.
                    </p>
                  </div>
                  <div className="login-body">
                    <Form onSubmit={this.forgotPassword}>
                      <div className="form-group">
                        <Input
                          id="UserId"
                          type="text"
                          name="UserId"
                          placeholder="User Name OR Mobile Number"
                          // validations={[validations.required]}
                          className="form-control"
                          onChange={this.onInputChange}
                        />
                      </div>
                      {/* <div className="form-group">
                        <Input
                          id="StudMobNo"
                          type="text"
                          name="StudMobNo"
                          placeholder="Mobile No"
                          validations={[validations.minLength]}
                          className="form-control"
                          onChange={this.onInputChange}
                        />
                      </div> */}
                      <div className="form-group mb-0">
                        <p>
                          Remember your password?&nbsp;
                          <span className="url" onClick={this.showLogin}>
                            Go to login
                          </span>
                        </p>
                      </div>
                      <div className="form-group login-submit">
                        <button
                          type="button"
                          disabled={
                            this.state.UserId.length > 0
                              ? // this.state.StudMobNo.length > 9
                                false
                              : true
                          }
                          onClick={this.SendOTPCode}
                          className="btn btn-primary btn-xl"
                        >
                          <i className="fa fa-unlock-alt" aria-hidden="true" />
                          &nbsp; Reset Password
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps({ auth, update, userDetailOTPForgotPass }) {
  return { auth, update, userDetailOTPForgotPass };
}
export default connect(
  mapStateToProps,
  { ...actions, ResendOtpDetails, clearUpdate }
)(Login);



// WEBPACK FOOTER //
// ./src/login/Login.js